/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ICheckoutSectionContainerItem, ICheckoutSectionContainerViewProps } from '@msdyn365-commerce-modules/checkout/src/modules/checkout-section-container/./checkout-section-container';

const ItemComponent: React.FC<ICheckoutSectionContainerItem> = ({ loading, itemProps, item }) => (
  <>
    {loading}
    <Node {...itemProps}>
      {item}
    </Node>
  </>
);

const CheckoutSectionContainerView: React.FC<ICheckoutSectionContainerViewProps> = ({ checkoutPlainContainerProps, items }) => {
  return(
    <Module {...checkoutPlainContainerProps}>
      {items.map(item => {
        // remove the hidden classname that is given in the checkout-section-container
        item.itemProps = { ...item.itemProps,
          className: 'ms-checkout-section-container__item'
        }
        return <ItemComponent key={item.id} {...item} />
      })}
    </Module>
  )
};

export default CheckoutSectionContainerView;
